import * as palette from "@govlaunch/palette";
import React from "react";
import { Hover } from "react-powerplug";
import Popover from "@govlaunch/popover";

interface ICounterIconProps extends React.HTMLAttributes<HTMLDivElement> {
  count: number | null;
  tooltip: string;
  width: number;
  height: number;
}

export default function CounterIcon({ count, tooltip, width, height, children, ...props }: ICounterIconProps) {
  return (
    <Hover>
      {({ hovered, bind }) => (
        <Popover
          isOpen={hovered}
          placement="top"
          render={() => {
            return (
              <div
                css={{
                  padding: 8,
                  color: palette.white,
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {tooltip}
              </div>
            );
          }}
          borderColor="transparent"
          backgroundColor={palette.innovatorBlue}
          boxStyle={{
            boxShadow: "0 2px 12px 0 rgba(0, 0, 0, 0.2)",
            zIndex: 9999,
          }}
        >
          {({ innerRef }: { innerRef: string }) => {
            return (
              <div
                {...props}
                {...bind}
                ref={innerRef}
                css={{
                  height: height,
                  width: width,
                  borderRadius: "100%",
                  display: "flex",
                  position: "relative",
                  float: "left",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <div
                  css={{
                    zIndex: 1,
                  }}
                >
                  {children}
                </div>
                <div
                  css={{
                    height: 18,
                    width: 18,
                    display: "flex",
                    position: "absolute",
                    right: -4,
                    bottom: -2,
                    backgroundColor: palette.innovatorBlue,
                    color: palette.white,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "100%",
                    zIndex: 2,
                    fontSize: 10,
                  }}
                >
                  {count && count > 99 ? "99+" : count}
                </div>
              </div>
            );
          }}
        </Popover>
      )}
    </Hover>
  );
}
